import { combineReducers } from 'redux';
import produce from 'immer';
import { BillingAction, BillingActionType } from '../../actions/billingActions';
import { Invoice } from '../../types/resources';

interface InvoiceState {
  invoiceIds: string[];
  invoiceById: Record<string, Invoice>;
}

export const initialState: InvoiceState = {
  invoiceIds: [],
  invoiceById: {},
};

const invoiceById = (state = initialState.invoiceById, action: BillingAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case BillingActionType.LIST_INVOICES:
        return {};
      case BillingActionType.LIST_INVOICES_OK: {
        action.data.forEach((invoice) => {
          draft[invoice.id] = invoice;
        });

        break;
      }
      default:
        return state;
    }
  });

const invoiceIds = (state = initialState.invoiceIds, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.LIST_INVOICES:
      return [];
    case BillingActionType.LIST_INVOICES_OK:
      return action.data.map((invoice) => invoice.id);
    default:
      return state;
  }
};

export default combineReducers({ invoiceById, invoiceIds });
